import { h as __h } from "preact";
import { Component } from "preact";
import { adminMemberResponse, groupResponse, locationResponse } from "~/backend/validate.js";
import { query, response } from "~/lib/api.js";
import html from "~/util/html.js";
import { navigate, pathname, search } from "~/util/router.js";
import Icon from "~/component/Icon.js";
import GroupChip from "~/admin/res/group/GroupChip.js";
import LocationChip from "~/admin/res/location/LocationChip.js";
import MemberChip from "~/admin/res/member/MemberChip.js";

/** @import { orgResponse } from "~/backend/validate.js"; */
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./AssignedToFilter.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./AssignedToFilter.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {orgResponse} org
 */
export default class AssignedToFilter extends Component {
  groupLookup = query(() => ({
    key: [`/v2/orgs/${this.props.org.id}/groups/${search.value.group_id ?? ""}`],
    enabled: Boolean(search.value.group_id),
    keepPreviousData: Boolean(search.value.group_id)
  }), {
    schema: response(groupResponse)
  });
  memberLookup = query(() => ({
    key: [`/ui/admin/orgs/${this.props.org.id}/members/${search.value.user_id ?? ""}`],
    enabled: Boolean(search.value.user_id),
    keepPreviousData: Boolean(search.value.user_id)
  }), {
    schema: response(adminMemberResponse)
  });
  locationLookup = query(() => ({
    key: [`/v2/orgs/${this.props.org.id}/locations/${search.value.location_id ?? ""}`],
    enabled: Boolean(search.value.location_id),
    keepPreviousData: Boolean(search.value.location_id)
  }), {
    schema: response(locationResponse)
  });
  render() {
    const {
      group_id: groupId,
      user_id: userId,
      location_id: locationId
    } = search.value;
    if (!groupId && !userId && !locationId) return null;
    const group = groupId ? this.groupLookup.data?.data : undefined;
    const member = userId ? this.memberLookup.data?.data : undefined;
    const location = locationId ? this.locationLookup.data?.data : undefined;
    return __h("div", {
      "class": css.filter
    }, __h("span", {
      "class": css.label
    }, "filtered by:"), group && __h(GroupChip, {
      group: {
        id: group.id,
        org_id: this.props.org.id,
        name: group.name
      }
    }), member && __h(MemberChip, {
      member: {
        id: member.id,
        org_id: this.props.org.id,
        name: member.name
      }
    }), location && __h(LocationChip, {
      location: {
        id: location.id,
        org_id: this.props.org.id,
        name: location.name
      }
    }), __h("button", {
      type: "button",
      "class": css.clear,
      "aria-label": "Clear filter",
      onClick: () => navigate(pathname.value)
    }, __h(Icon, {
      name: "ex",
      size: 10
    })));
  }
}